import React from 'react';
import { useNavigate } from 'react-router-dom';
import KuestionMark from '../kuestion/KuestionMark';
import { kq } from '../../config/routes';
import { TERMINALX_PATH } from '../../config/terminalx';
import terminalxIcon from '../../assets/images/terminalx/app.svg';
import './ApplicationsMenu.css';

/**
 * The Applications dropdown: Kuestion and TerminalX. Kuestion swaps the
 * landing page over to the Kuestion application page (triggerAltMenu), exactly
 * as Backupman used to; TerminalX has its own address and goes there.
 */
// Open state is owned by the navbar, which keeps this menu and the Knowledge
// base menu mutually exclusive and closes both on an outside click or Escape.
export default function ApplicationsMenu({ triggerAltMenu, onTerminalx, open = false, onToggle, onClose, menuRef }) {
  const navigate = useNavigate();

  return (
    <div className="rw-apps" ref={menuRef}>
      <button
        type="button"
        className="rw-nav__item"
        aria-expanded={open}
        aria-haspopup="true"
        onClick={onToggle}
      >
        Applications
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {open && (
        <div className="rw-apps__menu">
          <div className="rw-apps__count">2 applications</div>
          <button
            type="button"
            className="rw-apps__item"
            onClick={() => { if (onClose) onClose(); triggerAltMenu ? triggerAltMenu() : navigate(kq()); }}
          >
            <span className="rw-apps__tile">
              <KuestionMark bodyFill="currentColor" leafFill="currentColor" glyphFill="var(--color-accent)" />
            </span>
            <span>
              <span className="rw-apps__name">Kuestion</span>
              <span className="rw-apps__desc">Examination &amp; candidate testing</span>
            </span>
          </button>
          <button
            type="button"
            className="rw-apps__item rw-apps__item--next"
            onClick={() => { if (onClose) onClose(); onTerminalx ? onTerminalx() : navigate(TERMINALX_PATH); }}
          >
            <img className="rw-apps__icon" src={terminalxIcon} alt="" width="40" height="40" />
            <span>
              <span className="rw-apps__name">TerminalX</span>
              <span className="rw-apps__desc">Console client for network engineers</span>
            </span>
          </button>
        </div>
      )}
    </div>
  );
}
